// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CriteriosAvaliacoes_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/criterios_avaliacoes/save
 *
 * Saves (creates or updates) an evaluation criterion.
 * - If ID is provided and > 0: updates existing criterion
 * - If ID is missing or 0: creates new criterion
 */
import { registerContract } from './validate'

export interface CriteriosAvaliacoes_SaveInput {
name: string
ID?: number
}

registerContract('CriteriosAvaliacoes_SaveInput', {
  name: { type: 'string',  required: true },
  ID:   { type: 'number',  required: false },
})
